module.exports = __webpack_public_path__ + "img/WILK.e99344a2.png";